import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core/styles';

export const useProfessionalDevelopmentApprovalsStyles = makeStyles(
  (theme: Theme) => ({
    tabs: {
      borderBottom: '1px solid #e0e0e0',
      '& .MuiTab-root': {
        minWidth: 120,
        textTransform: 'none',
        fontSize: '1em',
        color: '#666666',
        '&.Mui-selected': {
          color: '#00588f',
          fontWeight: 600,
        },
      },
      '& .MuiTabs-indicator': {
        backgroundColor: '#00588f',
        height: 3,
      },
    },
    downloadButtonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(2),
    },
    downloadButton: {
      color: '#00588f',
      border: '1px solid #e0e0e0',
      borderRadius: '4px',
      padding: '8px',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    tableContainer: {
      overflowX: 'auto',
      marginTop: theme.spacing(2),
    },
    tableWrapper: {
      minWidth: 900,
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: theme.spacing(2),
    },
    tableHeader: {
      backgroundColor: '#f5f5f5',
      padding: '16px',
      textAlign: 'left',
      fontWeight: 600,
      fontSize: '0.95em',
      color: '#333333',
      borderBottom: '2px solid #e0e0e0',
    },
    tableRow: {
      '&:hover': {
        backgroundColor: '#fafafa',
      },
      '&:not(:last-child)': {
        borderBottom: '1px solid #e0e0e0',
      },
    },
    tableCell: {
      padding: '16px',
      fontSize: '0.95em',
      color: '#424242',
    },
    tableCellSub: {
      padding: '0px',
      fontSize: '0.75em',
      color: '#424242',
    },
    actionButtons: {
      display: 'flex',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
    approveButton: {
      backgroundColor: '#2d8fd5',
      '&:hover': {
        backgroundColor: '#267fc0',
      },
    },
    rejectButton: {
      backgroundColor: '#e3342f',
      '&:hover': {
        backgroundColor: '#cc2f2a',
      },
      marginLeft: theme.spacing(1),
    },
    approvedText: {
      color: '#4CAF50',
      fontWeight: 600,
    },
    rejectedText: {
      color: '#f44336',
      fontWeight: 600,
    },
    noData: {
      color: '#999999',
      fontSize: '1em',
      marginTop: theme.spacing(2),
    },
  })
);
